import { useState, useEffect } from "react";
import { X, Smartphone } from "lucide-react";

const PhonePromptBanner = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    // Check dismissal count
    const dismissCount = parseInt(localStorage.getItem("phone_banner_dismiss_count") || "0", 10);

    // Show banner only if dismissed less than 3 times
    if (dismissCount < 3) {
      setShowBanner(true);
    }
  }, []);

  const handleDismiss = () => {
    const currentCount = parseInt(localStorage.getItem("phone_banner_dismiss_count") || "0", 10);
    localStorage.setItem("phone_banner_dismiss_count", String(currentCount + 1));
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div
      style={{
        background: "#E8F5E9",
        color: "#1B5E20",
        padding: "0.75rem 1rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: "0.75rem",
        fontSize: "0.875rem",
        borderBottom: "1px solid #A5D6A7"
      }}
      data-testid="phone-prompt-banner"
    >
      <div style={{ display: "flex", alignItems: "center", gap: "0.5rem", flex: 1 }}>
        <Smartphone size={18} style={{ flexShrink: 0, color: "#25D366" }} />
        <span>
          <strong>For faster coordination</strong>, join our WhatsApp community.
        </span>
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", flexShrink: 0 }}>
        <a
          href="https://chat.whatsapp.com/LgawyQzg5jb3YGDQkRiEaO?mode=gi_t"
          target="_blank"
          rel="noopener noreferrer"
          style={{
            color: "white",
            fontWeight: "600",
            textDecoration: "none",
            padding: "0.35rem 0.75rem",
            background: "#25D366",
            borderRadius: "4px",
            fontSize: "0.8rem",
            whiteSpace: "nowrap"
          }}
          data-testid="phone-prompt-update-link"
        >
          Join →
        </a>
        <button
          onClick={handleDismiss}
          style={{
            background: "none",
            border: "none",
            color: "#1B5E20",
            cursor: "pointer",
            padding: "0.25rem",
            display: "flex",
            alignItems: "center",
            opacity: 0.6
          }}
          aria-label="Dismiss"
          data-testid="phone-prompt-dismiss"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
};

export default PhonePromptBanner;
